








































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'

import { getFieldError } from '@/core/tools/forms/get_field_error';
import { ServerResult } from '@/core/http/server_result';

import { STORE_KEY, store } from './_store';
import { QueryBuilder } from '@/core/uql';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'storages'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  components: {
  }
})
export default class WarehousesMoveForm extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;
  @Prop({ type: Array, default: () => [] }) rows!: any[];

  target_warehouse: any = null

  warehouses: any[] = [
    {id: 'unfinished', label: 'незавершенной продукции'},
    {id: 'disposal', label: 'утилизации'},
    {id: 'carantine', label: 'карантина'},
    {id: 'recycling', label: 'переработки'},
    {id: 'done', label: 'готовой продукции'},
  ]

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  saveFormData() {
    const saveQueries: any[] = this.rows.map((item: any, idx: number) => {
      return this.$q(`SAVE-${idx}`).update(item.plan_id, {
        state: this.target_warehouse
      })
    })
    this.$db(saveQueries).then((result: ServerResult) => {
      console.log(result)
        this.$buefy.snackbar.open(`Партрии перенесены`);

        this.$emit('form-close');
        (this.$parent as any).close();
      })

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

